import React from "react";
import { List, Datagrid, NumberField, DateField } from "admin-on-rest";
//import find from "lodash.find";
import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";
import { SimActions } from "./defaultValues";
import { EditButton } from "../components/button";
export const SimList = props => {
  return (
    <List
      {...props}
      actions={<SimActions />}
      title={<IconTitle icon="sim" title={"resources.sim.title"} />}
      sort={{ field: "created_at", order: "DESC" }}
      perPage={20}
      pagination={<Pagination />}
    >
      <Datagrid bodyOptions={{ showRowHover: true }}>
        <DateField label="resources.sim.field.date" source="created_at" />
        <NumberField label="resources.sim.field.total" source="total" />
        <NumberField label="resources.sim.field.sold" source="sold" />
        <EditButton label="" style={{ textAlign: "right" }} />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/sim/LIst.js